
<template>
    <Paper class='applianceCoefficient'>
        <m-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            :verification="verification"
            :pickerConfig="pickerConfig"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @save-btn="saveBtn"
            searchId="bms_appliance_coefficient_query">
            <!-- 按钮区-->
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                        <el-button class="bigData-btn-refresh" icon='el-icon-refresh' size="mini" @click="loadData" :loading="loading"></el-button>
                    </el-tooltip>
                    <el-tooltip class='item' effect='dark' content='导入' placement='bottom' v-has="'09010001'">
                        <el-button class="bigData-btn-import" icon='el-icon-upload2' size='mini' @click="onImport(true)"></el-button>
                    </el-tooltip>
                    <el-tooltip class='item' effect='dark' content='导出' placement='bottom' v-has="'09010001'">
                        <el-button class="bigData-btn-export" icon='el-icon-download' size='mini' :loading="exportLoading" @click='mexport'></el-button>
                    </el-tooltip>
                </div>
            </div>
            <div slot="page-module-btn">
                <el-button class="bigData-btn-send" type="primary" @click="send">推送待办人</el-button>
            </div>
        </m-panel>
        <import-dialog ref="importDialog" @reload="loadData" :exportTemplate="exportTemplate" tempTitle="外部资源模板" uploadPath="/analysis/importCostCalculate" />
        <sendDialog ref="sendDialog" @reload="loadData"/>
    </Paper>
</template>
<script>
import dayjs from 'dayjs';
import Paper from '@/components/core/paper/Paper';
import mPanel from '@/components/otpPanel';
// import mPanel from '@/components/supplierPanel';
import ImportDialog from './ImportDialog.vue';
import {configFun} from './config.js';
import lsrmapi from '../../../api/contract/warningTask';
import { mapGetters } from 'vuex';
import { dictWithUrl } from '@/components/lots/api';
import sendDialog from './sendDialog.vue'
export default {
    components: { Paper, mPanel,ImportDialog, sendDialog },
    data() {
        return {
            config: configFun(this),
            exportTemplate:lsrmapi.downloadTemplate,
            totalData: [],
            pageTotal: 100,
            editState: false,
            selectState: false,
            selectedRows: [],
            loading: false,
            exportLoading: false,
            page: {
                // pageSize: config.page.pageSize,
                // pageNo: config.page.pageNo
                pageSize: 10,
                pageNo: 1
            },
            searchQuery: {},
            pageID: 'lsrm_warning_task_20250725',
            verification: {
                businessType: [{ required: true, message: ' ', trigger: 'change' }],
                companyName: [{ required: true, message: ' ', trigger: 'blur' }],
                sendPosition: [{ required: true, message: ' ', trigger: 'blur' }],
                warnDays: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            dictData: {},
            pickerConfig: {
                shortcuts: [
                    {
                        text: '最近一周',
                        num: 6,
                    },
                    {
                        text: '最近一个月',
                        num: 30,
                    },
                    {
                        text: '最近三个月',
                        num: 90,
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode'])
    },
    methods: {
        send(){
            if (!this.selectedRows.length) {
                return this.$message.warning('请选择数据')
            }
            if (this.selectedRows.some(v => v.sendAccount)) {
                return this.$message.warning('当前数据存在待办人不为空，不能推送待办人')
            }
            this.$refs['sendDialog'].open(this.selectedRows)
        },
        saveBtn(data){
            let newContractCode=data.newContractCode;
            if(typeof newContractCode==='string'&&newContractCode.length>100){
                this.$message.warning('【新合同编号/终止原因/其他说明】字段不允许100个字符串');
                return
            }
            let params={
                contractCode:data.contractCode,
                newContractCode:data.newContractCode,
                completionSchedule:data.completionSchedule
            }
            this.loading = true;
            data.edit=-3;
            lsrmapi.contractWarningTaskEdit(params).then(res => {
                this.loadData();
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        getDictData() {
            return dictWithUrl('BID_BUSINESS_TYPE,CONTRACT_WARNING_TYPES,CONTRACT_WARNING_COM_SCHEDULE,SRM_CONTRACT_STATUS').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data;
                }
            });
        },
        selectChange(data) {
            if (data.length > 0) {
                this.selectState = true;
                this.selectedRows = data;
            } else {
                this.selectState = false;
                this.selectedRows = [];
            }
        },
        searchChange(data) {
            this.page.pageNo = 1;
            this.searchQuery = data;
            this.loadData();
        },
        pageChange(data) {
            this.page.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.page.pageSize = data;
            this.loadData();
        },
        addData() {
            this.$refs.tablePage.$refs.table.addData();
        },
        onImport(flag){
            this.$refs.importDialog.handleVisible(!!flag);
        },
        mexport() {
            const params = {
                ...this.searchQuery,
                moduleCode: this.$refs.tablePage.resourceCode,
                subjectType: this.pageID
            };
            const { expDateArr } = this.searchQuery
            if (expDateArr && expDateArr.length) {
                const expDateStart = dayjs(expDateArr[0])
                const expDateEnd = dayjs(expDateArr[1])
                const duration = expDateEnd.diff(expDateStart, 'day')
                // 判断时间范围是否超过3个月
                if (duration > 92) {
                    return this.$message.warning('合同失效时间范围不能超过3个月')
                } else {
                    params.expDateStart = expDateStart.format('YYYY-MM-DD HH:mm:ss')
                    params.expDateEnd = expDateEnd.format('YYYY-MM-DD HH:mm:ss')
                }
            }
            delete params.expDateArr
            delete params.suppliersName
            this.exportLoading = true
            lsrmapi.export(params).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '预警任务.xlsx';
                    a.click();
                    this.$message.success('导出成功！');
                }
            }).finally(() => { this.exportLoading = false });
        },
        // 格式化响应参数
        formatResponseData(array) {
            array.forEach(v => {
                v.type1Text = this.dictData.CONTRACT_WARNING_TYPES[v.type1];
                v.type2Text = this.dictData.CONTRACT_WARNING_TYPES[v.type2];
                v.type3Text = this.dictData.CONTRACT_WARNING_TYPES[v.type3];
                v.businessTypeText = this.dictData.BID_BUSINESS_TYPE[v.businessType];
                v._contractStatus = this.dictData.SRM_CONTRACT_STATUS[v.contractStatus];
                const completionSchedule = Object.entries(this.dictData.CONTRACT_WARNING_COM_SCHEDULE).map(v => ({ label: v[1], value: v[0] }));
                if (v.completionSchedule3) {
                    v.completionSchedule3Text = completionSchedule.find(e => e.value === v.completionSchedule3).label;
                }
            });
            return array;
        },
        loadData() {
            var params = {
                ...this.page,
                ...this.searchQuery
            };
            const { expDateArr } = this.searchQuery
            if (expDateArr && expDateArr.length) {
                const expDateStart = dayjs(expDateArr[0])
                const expDateEnd = dayjs(expDateArr[1])
                const duration = expDateEnd.diff(expDateStart, 'day')
                // 判断时间范围是否超过3个月
                if (duration > 92) {
                    return this.$message.warning('合同失效时间范围不能超过3个月')
                } else {
                    params.expDateStart = expDateStart.format('YYYY-MM-DD HH:mm:ss')
                    params.expDateEnd = expDateEnd.format('YYYY-MM-DD HH:mm:ss')
                }
            }
            delete params.expDateArr
            delete params.suppliersName
            this.loading = true;
            lsrmapi.get(params).then(res => {
                this.pageTotal = res.data.totalCount;
                this.totalData = res.data.list;
                for (let i = 0; i < this.totalData.length; i++) {
                    this.totalData[i].status = String(this.totalData[i].status);
                    this.totalData[i].warnDays = String(this.totalData[i].warnDays);
                    this.totalData[i].id = 'P'+i;
                    
                }
                this.editState = false;
                var setHiddenEventMap = new Map();
                setHiddenEventMap
                    .set('0', this.hiddenEventType = [ 'check' ]);
                setHiddenEventMap
                    .set('1', this.hiddenEventType = [ 'amend' ]);
                this.formatResponseData(res.data.list || []);
                this.totalData.forEach((subItem, subIndex) => {
                    if (subItem.status === '1' && (subItem.approvalStatus === null || subItem.approvalStatus === '40')) {
                        subItem.stampMode = '0';
                        subItem.hiddenEvent = this.hiddenEventType = setHiddenEventMap.get(subItem.stampMode);
                    } else if (subItem.status === '2' || subItem.approvalStatus === '20') {
                        subItem.hiddenEvent = ['check', 'amend'];
                    } else if (subItem.status === '1' && subItem.approvalStatus === '00') {
                        subItem.hiddenEvent = '';
                    } else {
                        subItem.stampMode = '1';
                        subItem.hiddenEvent = this.hiddenEventType = setHiddenEventMap.get(subItem.stampMode);
                    }
                });
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        getMipUrlFn(data) {
            let strUrl = '';
            const str = `?id=${data.contractCode}`;
            strUrl = location.origin + location.pathname + '#/warningTask' + str;
            lsrmapi.getMipUrl({
                'tenantCode': this.currentTenant.tenantCode,
                'appCode': this.applicationCode,
                'fdTemplateCode': 'srm_contract_warning_task',
                'loginName': this.$store.getters.user.userCode,
                'formParam': {
                    'subject': '合同管理-合同预警-' + this.$store.getters.user.userName,
                    'formInstanceId': data.contractCode,
                    'fdUrl': strUrl
                }
            }).then(res => {
                if (+res.code === 0) {
                    this.tomip(data.contractCode, res.data.fdId);
                }
            });
        },
        queryOneInstanceFn(data) {
            lsrmapi.queryOneInstance(data).then(res => {
                if (+res.code === 0) {
                    this.tomip(data.contractCode, res.data.fdId);
                }
            });
        },
        tomip(noticeCode, fdId) {
            this.$router.push({
                name: 'wtMipIframe',
                query: {
                    formInstanceId: noticeCode,
                    path: 'warningTask',
                    processId: fdId
                }
            });
        },
        // 服务平台根据分公司筛选
        setAdvanceUrl(companyCode) {
            this.siteParams.advanceUrl = companyCode ? `searchPlatform?companyCode=${companyCode}` : 'searchPlatform';
        },
        test() {
            this.$router.push('/warningTaskDetail');
        },
        // 动态设置供应商租户参数
        setSupplierAdvanceUrl() {
            const target = this.config.searchList.searchTxt.find(v => (v.value === 'suppliersName'));
            target && (target.advanceUrl = `/supplier/getSupplierInfosByNameAndCode?tenantCode=${this.currentTenant.tenantCode}`);
        },
    },
    async created() {
        await this.getDictData();
        this.loadData();
    },
    mounted(){
        //otpPanel组件不支持动态pageID，所以只能直接修改组件的值
        this.$refs['tablePage'].pageID = this.pageID
        this.setSupplierAdvanceUrl()
    }
};
</script>
<!-- 样式区 -->
<style lang='less'>
    .applianceCoefficient {
        #advanced-search{
            padding-bottom: 0;
        }

        .otp-inline-table.opt-table-with-table-height .el-table {
            height: calc(100vh - 207px) !important;
        }
    }
</style>
